import { render, staticRenderFns } from "./TitleQuestion.vue?vue&type=template&id=4a2e0c68&scoped=true"
import script from "./TitleQuestion.vue?vue&type=script&lang=js"
export * from "./TitleQuestion.vue?vue&type=script&lang=js"
import style0 from "./TitleQuestion.vue?vue&type=style&index=0&id=4a2e0c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2e0c68",
  null
  
)

export default component.exports